module.exports = __webpack_public_path__ + "img/f1.68e7cf25.png";